import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EUFundingCard from './EUFundingCard';
import './IntroSection.css'; // We'll create this CSS file

const IntroSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="intro-sections-container">
            {/* First Section */}
            <div className="intro-section-wrapper">
                <section className="intro-section-component">
                    <h2>{t('introSection.header')}</h2>
                    <div className="intro-content-component">
                        {/* Project image */}
                        <img src="/Trans_project.webp" alt="Craftsmanship and Transparency" className="intro-image-component" />
                        <p>
                            {t('introSection.paragraph')}
                        </p>
                    </div>
                </section>
            </div>

            {/* EU Funding Card */}
            <EUFundingCard />

            {/* Second Section (Identical for now)
            <div className="intro-section-wrapper">
                <section className="intro-section-component">
                    <h2>{t('introSection.header')}</h2>
                    <div className="intro-content-component">
                        <img src="/tr.jpg" alt="Craftsmanship and Transparency" className="intro-image-component" />
                        <p>
                            {t('introSection.paragraph')}
                        </p>
                    </div>
                </section>
            </div> */}
        </div>
    );
};

export default IntroSection;